import { tv } from "../../../variants/tv.js";
const overlayTitleVariants = tv({
    slots: {
        root: 'relative grid w-full grid-cols-[40px_1fr_28px] gap-1 px-2',
        headingClass: 'flex items-center justify-center',
        subHeadingClass: 'inline-flex h-6'
    }
});
export { overlayTitleVariants };
